import { AfterContentInit, Component, Inject, NgZone } from '@angular/core';
import { UserOnboardingInitService } from '../../services/user-onboarding-init.service';
import {
  TOKENS as MASTERDATA_TOKENS,
  UserFlowService,
} from '@trustedshops/tswp-core-masterdata';

@Component({
  selector: 'app-userflow-trigger',
  templateUrl: './userflow-trigger.component.html',
  styleUrls: ['./userflow-trigger.component.scss'],
  standalone: false
})
export class UserflowTriggerComponent implements AfterContentInit {
  public isOpened = false;

  public constructor(
    @Inject(MASTERDATA_TOKENS.UserFlowService)
    private readonly userFlowService: UserFlowService,
    public readonly userFlowInitService: UserOnboardingInitService,
    private readonly _ngZone: NgZone,
  ) { }

  public ngAfterContentInit(): void {
    this.isOpened = this.isChecklistInDOM;

    this.userFlowService.userflow.on('flowEnded', this.flowEnded.bind(this));
  }

  public get isChecklistInDOM(): boolean {
    return !!document.getElementById('userflow-ui');
  }

  public toggleChecklist(): void {
    if (this.isChecklistInDOM) {
      this.closeChecklist();
    } else {
      this.userFlowService.userflow.start(this.userFlowInitService.ongoingOnboardingId).then(() => {
        this.isOpened = true;
      });
    }
  }

  public closeChecklist(): void {
    this.userFlowService.userflow.endAll().then(() => {
      this.isOpened = false;
    });
  }

  /**
   * Workaround to update the progress after the flow has ended
   * We need to run the change detection manually, because the event is not triggered inside the Angular zone
   * INFO: We have to wait a bit, because the event is triggered before the progress is updated
   */
  private flowEnded() {
    setTimeout(() => {
      this._ngZone.run(() => {
        this.userFlowInitService.loadProgress().subscribe();
      });
    }, 1000);
  }
}
